import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Software from "@/pages/Software";
import TaxCalculator from "@/pages/TaxCalculator";
import FAQs from "@/pages/FAQs";
import Contact from "@/pages/Contact";
import Checklists from "@/pages/Checklists";
import YearEndTaxChecklist from "@/pages/checklists/YearEndTax";
import SBCQualifier from "@/pages/checklists/SBCQualifier";
import ProvisionalTaxQualifier from "@/pages/checklists/ProvisionalTax";
import PISCalculator from "@/pages/checklists/PISCalculator";
import VATRegistrationDecision from "@/pages/checklists/VATRegistration";
import VATInvoiceChecklist from "@/pages/checklists/VATInvoice";
import RingFencing from "@/pages/checklists/RingFencing";
import TaxNumber from "@/pages/TaxNumber";
import IT77Form from "@/pages/IT77Form";
import XeroComparison from "@/pages/XeroComparison";
import PackageMatchmaker from "@/pages/PackageMatchmaker";
import Structures from "@/pages/Structures";
import AdminInquiries from "@/pages/admin/AdminInquiries";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function App() {
    return (
        <div className="App font-sans" data-testid="app-root">
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <main data-testid="main-content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/software" element={<Software />} />
                        <Route path="/tax-calculator" element={<TaxCalculator />} />
                        <Route path="/checklists" element={<Checklists />} />
                        <Route path="/checklists/year-end-tax" element={<YearEndTaxChecklist />} />
                        <Route path="/checklists/sbc-qualifier" element={<SBCQualifier />} />
                        <Route path="/checklists/provisional-tax" element={<ProvisionalTaxQualifier />} />
                        <Route path="/checklists/pis-calculator" element={<PISCalculator />} />
                        <Route path="/checklists/vat-registration" element={<VATRegistrationDecision />} />
                        <Route path="/checklists/vat-invoice" element={<VATInvoiceChecklist />} />
                        <Route path="/checklists/ring-fencing" element={<RingFencing />} />
                        <Route path="/tax-number" element={<TaxNumber />} />
                        <Route path="/tax-number/electronic" element={<IT77Form />} />
                        <Route path="/software/xero-comparison" element={<XeroComparison />} />
                        <Route path="/pricing/matchmaker" element={<PackageMatchmaker />} />
                        <Route path="/structures" element={<Structures />} />
                        <Route path="/admin" element={<AdminInquiries />} />
                        <Route path="/faqs" element={<FAQs />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </div>
    );
}

export default App;
